import { render, staticRenderFns } from "./MAM_editInfo.vue?vue&type=template&id=4067aefa&scoped=true&"
import script from "./MAM_editInfo.vue?vue&type=script&lang=js&"
export * from "./MAM_editInfo.vue?vue&type=script&lang=js&"
import style0 from "./MAM_editInfo.vue?vue&type=style&index=0&id=4067aefa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4067aefa",
  null
  
)

export default component.exports